import { isNotNilOrEmpty } from '@src/shared/src/util/general';
import { BasketItemModel, BookingItemModel } from '@src/shared/src/models';

export const getFailedMessageSource = (
  bookingItems: BookingItemModel[],
  basketItems: BasketItemModel[],
) => {
  const bookingWithMessage = bookingItems.find((item) => isNotNilOrEmpty(item.lastErrorMessage));
  if (bookingWithMessage?.lastErrorMessage) {
    return bookingWithMessage.lastErrorMessage;
  }

  const basketWithMessage = basketItems.find(
    (item) => isNotNilOrEmpty(item.travelBookingItem?.lastErrorMessage),
  );

  return basketWithMessage?.travelBookingItem?.lastErrorMessage;
};

export const getFailedMessageStatus = (bookingItems: BookingItemModel[]) =>
  bookingItems.find((item) => isNotNilOrEmpty(item.lastErrorStatus))?.lastErrorStatus;
